import { h } from 'preact';

export const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.3485 6.34202H9.65472V0.651466C9.65472 0.29316 9.36156 0 9.00326 0H6.99349C6.63518 0 6.34202 0.29316 6.34202 0.651466V6.34202H0.651466C0.29316 6.34202 0 6.63518 0 6.99349V9.00326C0 9.36156 0.29316 9.65472 0.651466 9.65472H6.34202V15.3485C6.34202 15.7068 6.63518 16 6.99349 16H9.00326C9.36156 16 9.65472 15.7068 9.65472 15.3485V9.65472H15.3485C15.7068 9.65472 16 9.36156 16 9.00326V6.99349C16 6.63518 15.7068 6.34202 15.3485 6.34202Z" fill="white" />
  </svg>
)